module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showNavi) ? _c('nav', {
    attrs: {
      "id": "nav"
    }
  }, [_c('div', {
    staticClass: "nav-wrapper"
  }, [_c('a', {
    staticClass: "show-mobile-navigation",
    attrs: {
      "href": "#",
      "id": "mobile-navigation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openNavigation.apply(null, arguments)
      }
    }
  }, [_vm._v("Aktuell")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "i_1_0",
      "to": "/",
      "exact-active-class": "is-active"
    },
    on: {
      "focus": _vm.scrollToTop
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNavigation.apply(null, arguments)
      }
    }
  }, [_vm._v("Aktuell")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "i_1_1",
      "to": "/bahnnostalgie",
      "exact-active-class": "is-active"
    },
    on: {
      "focus": _vm.scrollToTop
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNavigation.apply(null, arguments)
      }
    }
  }, [_vm._v("Bahnnostalgie")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "i_1_2",
      "to": "/bahntechnik",
      "exact-active-class": "is-active"
    },
    on: {
      "focus": _vm.scrollToTop
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNavigation.apply(null, arguments)
      }
    }
  }, [_vm._v("Bahntechnik")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "i_1_3",
      "to": "/bahnziele",
      "exact-active-class": "is-active"
    },
    on: {
      "focus": _vm.scrollToTop
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNavigation.apply(null, arguments)
      }
    }
  }, [_vm._v("Bahnziele")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "i_1_4",
      "to": "/modelleisenbahn",
      "exact-active-class": "is-active"
    },
    on: {
      "focus": _vm.scrollToTop
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNavigation.apply(null, arguments)
      }
    }
  }, [_vm._v("Modelleisenbahn")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "i_1_5",
      "to": "/info",
      "exact-active-class": "is-active"
    },
    on: {
      "focus": _vm.scrollToTop
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNavigation.apply(null, arguments)
      }
    }
  }, [_vm._v("Über")])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfd7623a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 93
// module chunks = 0